module.exports = __webpack_public_path__ + "static/media/vendas.07f14b71.png";